<script setup>
import { computed } from 'vue';

const props = defineProps({
    modelValue: {
        type: Array,
        default: () => [],
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue']);

// FHIR Timing.repeat.dayOfWeek codes, not the iCal MO/TU vocabulary BnCalendarRecurring uses.
// Three letters, not one: M/T/W/T/F/S/S repeats T and S, which is ambiguous on screen and
// indistinguishable to a screen reader. The full name is the accessible name.
const days = [
    { code: 'mon', label: 'Mon', name: 'Monday', dataCy: 'dayOfWeekMon' },
    { code: 'tue', label: 'Tue', name: 'Tuesday', dataCy: 'dayOfWeekTue' },
    { code: 'wed', label: 'Wed', name: 'Wednesday', dataCy: 'dayOfWeekWed' },
    { code: 'thu', label: 'Thu', name: 'Thursday', dataCy: 'dayOfWeekThu' },
    { code: 'fri', label: 'Fri', name: 'Friday', dataCy: 'dayOfWeekFri' },
    { code: 'sat', label: 'Sat', name: 'Saturday', dataCy: 'dayOfWeekSat' },
    { code: 'sun', label: 'Sun', name: 'Sunday', dataCy: 'dayOfWeekSun' },
];

const selected = computed({
    get: () => props.modelValue || [],
    // Re-derive from the canonical Mon..Sun order so the emitted array never reflects click order.
    set: (value) =>
        emit(
            'update:modelValue',
            days.map((day) => day.code).filter((code) => (value || []).includes(code)),
        ),
});
</script>

<template>
    <v-chip-group v-model="selected" multiple class="mt-0" data-cy="dayOfWeekToggle">
        <div class="d-flex flex-wrap ga-1 fill-width" style="max-width: 420px">
            <v-chip
                v-for="day in days"
                :key="day.code"
                :value="day.code"
                label
                :variant="selected.includes(day.code) ? 'tonal' : 'outlined'"
                :color="selected.includes(day.code) ? 'primary' : undefined"
                :disabled="props.disabled"
                :aria-label="day.name"
                :data-cy="day.dataCy"
                class="px-3"
                >{{ day.label }}</v-chip
            >
        </div>
    </v-chip-group>
</template>
